import './App.css';
import "./style/global.css"
import WebRoutes from './routes/AllRoutes';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <div className="App">
      <ToastContainer />
      <WebRoutes />
    </div>
  );
}

export default App;
